import React from "react";
import "./Dashboard.css";

const Dashboard: React.FC = () => {
  const stats = [
    {
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/family_4778835%201.svg",
      title: "Family Members",
      subtitle: "(Residents)",
      value: "04",
    },
    {
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/Vector.svg",
      title: "Domestic Helpers",
      subtitle: "",
      value: "10",
    },
    {
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/Frame%202147223842.svg",
      title: "Relative & Friends",
      subtitle: "",
      value: "12",
    },
  ];
  const items = [
    {
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/text_13065623%201.svg",
      title: "Draft",
    },
    {
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/id_6705044%201.svg",
      title: "Emirates ID",
    },
    {
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/boy_12748887%201.svg",
      title: "Residence",
    },
    {
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/travel_14538057%201.svg",
      title: "Passport",
    },
  ];
  const quickLinksData = [
    {
      title: "Profile",
      color: "#27AE9F",
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/Group%20496.svg",
    },
    {
      title: "Address",
      color: "#2C4A77",
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/Group%20497.svg",
    },
    {
      title: "Documents",
      color: "#6E42E5",
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/Group%20575.svg",
    },
    {
      title: "Applicant",
      color: "#E2B23A",
      icon: "https://goodhand.b-cdn.net/Assets/Accounts/les.svg",
    },
  ];
  const ordersData = [
    {
      title: "Completed Orders",
      count: 562,
      svgColor: "#6E42E5", // purple
    },
    {
      title: "Processing Orders",
      count: 1892,
      svgColor: "#2ECC71", // green
    },
    {
      title: "Cancel Orders",
      count: 62,
      svgColor: "#2C4A77", // blue
    },
  ];
  const chartSvg = (strokeColor: any) => (
    <svg
      width="174"
      height="59"
      viewBox="0 0 174 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="21.5" y="25.5" width="5" height="29" rx="2.5" fill="#F6F3FF" />
      <rect x="0.5" y="15.5" width="5" height="39" rx="2.5" fill="#F6F3FF" />
      <rect x="105.5" y="0.5" width="5" height="54" rx="2.5" fill="#F6F3FF" />
      <rect x="63.5" y="15.5" width="5" height="39" rx="2.5" fill="#F6F3FF" />
      <rect x="126.5" y="33.5" width="5" height="21" rx="2.5" fill="#F6F3FF" />
      <rect x="42.5" y="21.5" width="5" height="33" rx="2.5" fill="#F6F3FF" />
      <rect x="147.5" y="39.5" width="5" height="15" rx="2.5" fill="#F6F3FF" />
      <rect x="168.5" y="21.5" width="5" height="33" rx="2.5" fill="#F6F3FF" />
      <path
        d="M3.5 17.3439C9 24.6772 23.7296 36.4917 34.5 21.8439C47 4.84387 57.5 14.8439 62.5 18.8439C67.7527 23.0462 80.5 26.3439 90.5 10.8439C100.5 -4.65612 113 1.84389 117.5 10.8439C121.719 19.2819 137.914 35.3093 149.5 27.3439C157.5 21.8439 164 9.34386 173 13.3439"
        stroke={strokeColor}
      />
    </svg>
  );
  return (
    <>
      <div className=" row my-detail up-form layout-border rounded-3">
        <div className="d-flex justify-content-between align-items-center mb-1 p-3 border-bottom py-2 d-none d-md-flex">
          <div>
            <h1 className="ff-semibold text-black mb-1 font-18">My Detail</h1>
            <p className="font-14 text-muted mb-0">
              Easily add, update, or delete any information in your account
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-start gap-3 p-3 py-4 bg-white border-bottom">
          {stats.map((item, idx) => (
            <div
              key={idx}
              className="d-flex flex-column justify-content-between p-3 rounded-3"
              style={{
                backgroundColor: "#F3F8FF",
                width: "200px",
                height: "100px",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    background: "#fff",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                  }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    style={{ width: "22px", height: "22px" }}
                  />
                </div>
                <div>
                  <div style={{ fontWeight: "600", fontSize: "14px" }}>
                    {item.title}
                  </div>
                  {item.subtitle && (
                    <div style={{ fontSize: "12px", color: "#666" }}>
                      {item.subtitle}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "20px",
                  textAlign: "right",
                }}
              >
                {item.value}
              </div>
            </div>
          ))}
        </div>

        <div className="p-3 border-bottom py-4">
          <h6 className="mb-3 font-18 ff-bold">My Documents</h6>
          <div className="row g-3">
            {items.map((item, idx) => (
              <div className="col-auto" key={idx}>
                <div className="favorite-card d-flex align-items-center gap-2 p-3">
                  {/* Icon circle */}
                  <div className="favorite-icon-circle">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="favorite-icon-img"
                    />
                  </div>

                  {/* Title */}
                  <span className="fw-semibold font-14">{item.title}</span>

                  {/* Star top-right */}
                  <img
                    src="https://goodhand.b-cdn.net/Assets/Accounts/Frame%202147223849.svg"
                    alt="favorite"
                    className="favorite-star"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="p-3 py-4 border-bottom">
          <h6 className="mb-3 font-18 ff-bold">Quick Links</h6>
          <div className="d-flex flex-wrap gap-3">
            {quickLinksData.map((item, idx) => (
              <div key={idx} className="quicklink-card">
                <span className="quicklink-title">{item.title}</span>

                <div
                  className="quicklink-icon"
                  style={{ backgroundColor: item.color }}
                >
                  <img src={item.icon} alt={item.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="p-3">
          <h6 className="mb-3 font-16 fw-bold">My Orders</h6>
          <div className="d-flex flex-wrap gap-3">
            {ordersData.map((order, idx) => (
              <div key={idx} className="orders-card">
                <span className="orders-title">{order.title}</span>

                <span className="orders-count">{order.count}</span>

                <img
                  src="https://goodhand.b-cdn.net/Assets/Accounts/Frame%202147223862.svg"
                  alt="arrow"
                  className="orders-arrow"
                />

                {chartSvg(order.svgColor)}
              </div>
            ))}
          </div>
        </div>

        <div className="p-3">
          <img
            src="https://goodhand.b-cdn.net/Assets/Accounts/Frame%202147223850.png"
            className="img-fluid"
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
